
/*
 * VNCcontact+ : A new level of contact management
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { Component, OnInit, NgZone, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { BroadcastKeys } from "src/app/common/enums/broadcast.enum";
import { takeUntil } from "rxjs/operators";
import { TranslateService } from "@ngx-translate/core";
import { Broadcaster } from "src/app/common/providers/broadcaster.service";
import { ConfigService } from "src/app/common/providers/config.service";
import { Subject } from "rxjs";
import { AppConstants } from "src/app/common/utils/app-constants";

@Component({
  selector: "vp-help-faq-dialog",
  templateUrl: "./help-faq-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HelpFaqDialogComponent implements OnInit, OnDestroy {

  faqURL: string;
  userManual: string;
  private isAlive$ = new Subject<boolean>();

  constructor(
    public dialogRef: MatDialogRef<HelpFaqDialogComponent>,
    private broadcaster: Broadcaster,
    private ngZone: NgZone,
    private translateService: TranslateService,
    private changeDetectionRef: ChangeDetectorRef,
    private configService: ConfigService
  ) {
    this.broadcaster.on<any>(BroadcastKeys.HIDE_FAQ_DIALOG).pipe(takeUntil(this.isAlive$)).subscribe(res => {
      this.ngZone.run(() => {
        this.close();
      });
    });
    let browserLang = this.translateService.getBrowserLang();
    const localLang = localStorage.getItem(AppConstants.CONTACT_LANGUAGE);
    if (localLang !== null && localLang !== undefined && localLang !== "undefined") {
      browserLang = localLang;
    }
    browserLang = browserLang.match(/en|de/) ? browserLang : "en";
    if (browserLang === "en") {
      if (this.configService.URLS.faq) {
        this.faqURL = this.configService.URLS.faq;
      } else {
        this.faqURL = "https://en.docs.vnc.biz/vnccontacts/faq/";
      }
      if (this.configService.URLS.userManual) {
        this.userManual = this.configService.URLS.userManual;
      } else {
        this.userManual = "https://en.docs.vnc.biz/vnccontacts/vnccontacts_webclient/";
      }
    } else {
      if (this.configService.URLS.faq_de) {
        this.faqURL = this.configService.URLS.faq_de;
      } else {
        this.faqURL = "https://de.docs.vnc.biz/vnccontacts/faq/";
      }
      if (this.configService.URLS.userManual_de) {
        this.userManual = this.configService.URLS.userManual_de;
      } else {
        this.userManual = "https://de.docs.vnc.biz/vnccontacts/vnccontacts_webclient/";
      }
    }
    this.changeDetectionRef.markForCheck();
  }

  ngOnInit() {
  }

  close(): void {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.isAlive$.next(false);
    this.isAlive$.complete();
  }

}
